require("prismjs/themes/prism-okaidia.css")

const MEASUREMENT_ID =
  process.env.GATSBY_GA4_MEASUREMENT_ID ||
  process.env.GATSBY_GA_MEASUREMENT_ID ||
  "G-BTK72PT2D9"

exports.onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined") return

  const page_path =
    location.pathname + (location.search || "") + (location.hash || "")

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event: "page_view", page_path })
  }

  if (typeof window.gtag === "function" && MEASUREMENT_ID) {
    window.gtag("event", "page_view", {
      page_path,
      send_to: MEASUREMENT_ID,
    })
  }
}
